/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_With_LabelInputs */



/**
* | output |
* | --- |
* | "Who is it with?" |
*
* @param {Manual_Meeting_With_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_with_label = /** @type {((inputs?: Manual_Meeting_With_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_With_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Met wie?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avec qui ?")
	return /** @type {LocalizedString} */ ("Who is it with?")
});